export default __webpack_public_path__ + "static/media/README.c0bd5cb6.md";